import axios from 'axios';

export const api = axios.create({
  baseURL: `${
    window.location.hostname.indexOf('localhost') > -1
      ? 'http://localhost:5000/'
      : 'portas-abertas/'
  }`,
});

export const geocodeServices = axios.create({
    baseURL: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer',
});